import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_CLIMATE_STRIKE_LOGO = defineFcm('enable_climate_strike_logo')
	.asBoolean()
	.withDefault(false)
	.toConfig();
